/**
 * @generated SignedSource<<cf54ee285f7ff5f081b5466740dc73df>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OrderEnum = "ASC" | "DESC";
export type TermObjectsConnectionOrderbyEnum = "COUNT" | "DESCRIPTION" | "NAME" | "SLUG" | "TERM_GROUP" | "TERM_ID" | "TERM_ORDER";
export type RootQueryToTagConnectionWhereArgs = {
  cacheDomain?: string | null | undefined;
  childOf?: number | null | undefined;
  childless?: boolean | null | undefined;
  descriptionLike?: string | null | undefined;
  exclude?: ReadonlyArray<string | null | undefined> | null | undefined;
  excludeTree?: ReadonlyArray<string | null | undefined> | null | undefined;
  hideEmpty?: boolean | null | undefined;
  hierarchical?: boolean | null | undefined;
  include?: ReadonlyArray<string | null | undefined> | null | undefined;
  name?: ReadonlyArray<string | null | undefined> | null | undefined;
  nameLike?: string | null | undefined;
  objectIds?: ReadonlyArray<string | null | undefined> | null | undefined;
  order?: OrderEnum | null | undefined;
  orderby?: TermObjectsConnectionOrderbyEnum | null | undefined;
  padCounts?: boolean | null | undefined;
  parent?: number | null | undefined;
  search?: string | null | undefined;
  slug?: ReadonlyArray<string | null | undefined> | null | undefined;
  termTaxonomyId?: ReadonlyArray<string | null | undefined> | null | undefined;
  updateTermMetaCache?: boolean | null | undefined;
};
export type Tags_Pagination_Query$variables = {
  after?: string | null | undefined;
  first?: number | null | undefined;
  where?: RootQueryToTagConnectionWhereArgs | null | undefined;
};
export type Tags_Pagination_Query$data = {
  readonly " $fragmentSpreads": FragmentRefs<"Tag_Pagination_Fragment">;
};
export type Tags_Pagination_Query = {
  response: Tags_Pagination_Query$data;
  variables: Tags_Pagination_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "after"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "first"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "where"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "where",
    "variableName": "where"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "Tags_Pagination_Query",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "FragmentSpread",
        "name": "Tag_Pagination_Fragment"
      }
    ],
    "type": "RootQuery",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "Tags_Pagination_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RootQueryToTagConnection",
        "kind": "LinkedField",
        "name": "tags",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RootQueryToTagConnectionEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Tag",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "count",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "description",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RootQueryToTagConnectionPageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v1/*: any*/),
        "filters": [
          "where"
        ],
        "handle": "connection",
        "key": "Tags_Pagination_Fragment_Connection_tags",
        "kind": "LinkedHandle",
        "name": "tags"
      }
    ]
  },
  "params": {
    "cacheID": "efed5945ba60d4e54bdd52c3668da704",
    "id": null,
    "metadata": {},
    "name": "Tags_Pagination_Query",
    "operationKind": "query",
    "text": "query Tags_Pagination_Query(\n  $after: String\n  $first: Int\n  $where: RootQueryToTagConnectionWhereArgs\n) {\n  ...Tag_Pagination_Fragment_3sueo6\n}\n\nfragment Tag_Pagination_Fragment_3sueo6 on RootQuery {\n  tags(first: $first, after: $after, where: $where) {\n    edges {\n      node {\n        id\n        name\n        count\n        description\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "24adaf1b057cd6406a501dd4ef4d5d43";

export default node;
